import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/masterFormUpdate';
import Table from '../../Tables/DataTable/components/DataTable';
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const MasterFormUpdate = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">MASTER MANAGEMENT - Update</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

MasterFormUpdate.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(MasterFormUpdate);
